import {DOCUMENT} from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit, OnDestroy,
} from "@angular/core";
import {RightSidebarService} from "../../shared/services/rightsidebar.service";
import {ConfigService} from "../../shared/services/config.service";
import {Router} from "@angular/router";
import {AuthenticationService} from 'src/app/_services/authentication.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IAccount} from 'src/app/_models/account/IAccount';
import {GuestService} from "../../_services/guest.service";
import {IGuestAuthentication} from "../../_models/guest/IGuestAuthentication";
import {Subscription} from "rxjs";
import { ConfigurationService } from "src/app/_services/configuration.service";
import { IConfiguration } from "src/app/_models/configuration/IConfiguration";
import { environment } from "src/environments/environment";

const document: any = window.document;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  subscriptions = new Subscription();
  public config: any = {};
  userImg: string;
  homePage: string;
  isNavbarCollapsed = true;
  isGuest = false;
  account: IAccount;
  configurations: IConfiguration[] = [];
  customPublicInterface = false;
  clinicName = "";

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private dataService: RightSidebarService,
    private configService: ConfigService,
    private authenticationSerice: AuthenticationService,
    private snackBar: MatSnackBar,
    private router: Router,
    private authenticationService: AuthenticationService,
    private guestService: GuestService,
    private configurationService: ConfigurationService
  ) {
  }

  ngOnInit() {
    this.config = this.configService.configData;
    this.account = this.authenticationService.getAccount();

    const sub = this.guestService.guest.subscribe(
      (res: IGuestAuthentication) => {
        if (res) {
          this.isGuest = true;
        }
      }
    );
    this.subscriptions.add(sub);

    // custom public interface
    if (environment.customInterface) {
      this.customPublicInterface = true;
      this.clinicName = "...";
    }

    this.getConfigurations();
  }

  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem("theme")) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem("menuOption")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("menuOption")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "menu_" + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem("choose_logoheader")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("choose_logoheader")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "logo-" + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem("sidebar_status")) {
      if (localStorage.getItem("sidebar_status") === "close") {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      } else {
        this.renderer.removeClass(this.document.body, "side-closed");
        this.renderer.removeClass(this.document.body, "submenu-closed");
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }

  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains("side-closed");
    if (hasClass) {
      this.renderer.removeClass(this.document.body, "side-closed");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    } else {
      this.renderer.addClass(this.document.body, "side-closed");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }

  public toggleRightSidebar(): void {
    this.dataService.changeMsg(
      (this.dataService.currentStatus._isScalar = !this.dataService
        .currentStatus._isScalar)
    );
  }

  logout() {
    this.authenticationSerice.doLogout().subscribe(
      (res: boolean) => {
        if (res) {
          this.router.navigate(["/authentication/signin"]);
        }
      },
      error => {
        this.showNotification("snackbar-danger", error, "bottom", "right");
      }
    );
  }

  private showNotification(colorName, text, placementFrom, placementAlign) {
    this.snackBar.open(text, "", {
      duration: 3000,
      verticalPosition: placementFrom,
      horizontalPosition: placementAlign,
      panelClass: colorName,
    });
  }

  private getConfigurations() {
    const sub = this.configurationService.getConfigurations(true).subscribe(
      (res: IConfiguration[]) => {
        this.configurations = res;

        let clinicNameConfig = this.configurations.find(x => x.key === 'clinicName');
        if (clinicNameConfig && clinicNameConfig.value != "") {
          this.clinicName = clinicNameConfig.value;
        }
      });
    this.subscriptions.add(sub);
  }
}
